import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-vital-flag-wizard-dialog',
  templateUrl: './vital-flag-wizard-dialog.component.html',
  styleUrls: ['./vital-flag-wizard-dialog.component.scss']
})
export class VitalFlagWizardDialogComponent implements OnInit {

  constructor(private dialogRef: MatDialogRef<VitalFlagWizardDialogComponent>) {}

  ngOnInit(): void {}

  closeDialog(event: boolean): void {
    if (event) {
      this.dialogRef.close();
    }
  }
}
